import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from '../../services/core/config.service';
import { UserSessionService } from '../../services/user.service';

/**
 * Point de passage vers l'application EXTERNE GESTAC (brique « Pilotage Accords Commerciaux »).
 *
 * GESTAC est une application externe à PFA : elle est ouverte dans un nouvel onglet et n'est pas
 * servie par PFA. Elle ne passe donc pas par `PowerBi/generateToken` : la navigation n'est pas
 * journalisée par le middleware serveur via ce canal. Pour tracer l'accès « comme les autres
 * modules », on appelle `User/officines?...&type=Accords_commerciaux` (le middleware
 * `LogRequestMiddleware` journalise la navigation d'après le paramètre `type`).
 *
 * Ce composant sert de trampoline pour la route interne `pilotageaccordscommerciaux` (le menu
 * latéral kit-ui ne sait naviguer que sur des routes internes) : il envoie le log, ouvre GESTAC
 * dans un nouvel onglet, puis ramène la fenêtre PFA sur l'accueil.
 */
@Component({
  selector: 'app-redirect-gestac',
  standalone: true,
  template: '',
})
export class RedirectGestacComponent implements OnInit {
  constructor(
    private readonly configService: ConfigService,
    private readonly userService: UserSessionService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    const gestacUrl = this.configService.config.modules.gestac;
    const currentUser = localStorage.getItem('currentUserCockpit');
    const email = currentUser ? JSON.parse(currentUser).email : '';

    // Log de navigation « comme les autres modules » (type Accords_commerciaux), en fire-and-forget.
    // Le service porte son propre takeUntil (racine), la requête aboutit même après destruction du composant.
    if (email) {
      this.userService.getOfficine(email, 'Accords_commerciaux').subscribe({
        error: () => {},
      });
    }

    // GESTAC est externe : ouverture dans un nouvel onglet (synchrone, pour éviter le blocage popup),
    // puis retour de la fenêtre PFA sur l'accueil (le trampoline n'affiche aucune page).
    // `noopener,noreferrer` : coupe l'accès à `window.opener` (protection reverse-tabnabbing) et le Referer.
    window.open(gestacUrl, '_blank', 'noopener,noreferrer');
    void this.router.navigate(['']);
  }
}
